// REQ-40 (Faz-7) — servis API anahtarı API client (security.manage).
//
// Uçlar `/api/v1/admin/api-keys`. Düz metin anahtar YALNIZCA generate/rotate
// yanıtında bir kez döner; liste yalnız name/prefix/durum/tarihleri taşır.

import { http, unwrap, unwrapList, type ActionResponse } from './http';
import type { ApiKey, GeneratedApiKey } from '@features/api-keys/types';

interface ApiKeyDtoWire {
  id?: string | null;
  name?: string | null;
  prefix?: string | null;
  isActive?: boolean | null;
  createdAt?: string | null;
  lastUsedAt?: string | null;
  revokedAt?: string | null;
}

interface GeneratedApiKeyDtoWire {
  id?: string | null;
  name?: string | null;
  prefix?: string | null;
  key?: string | null;
  createdAt?: string | null;
}

const BASE = '/api/v1/admin/api-keys';

function mapKey(d: ApiKeyDtoWire): ApiKey {
  return {
    id: d.id ?? '',
    name: d.name ?? '',
    prefix: d.prefix ?? '',
    isActive: d.isActive ?? false,
    createdAt: d.createdAt ?? '',
    lastUsedAt: d.lastUsedAt ?? null,
    revokedAt: d.revokedAt ?? null,
  };
}

function mapGenerated(d: GeneratedApiKeyDtoWire): GeneratedApiKey {
  return {
    id: d.id ?? '',
    name: d.name ?? '',
    prefix: d.prefix ?? '',
    key: d.key ?? '',
    createdAt: d.createdAt ?? '',
  };
}

export const apiKeysApi = {
  async list(): Promise<ApiKey[]> {
    const res = await http.get<ActionResponse<ApiKeyDtoWire>>(BASE);
    const { items } = unwrapList(res);
    return items.map(mapKey);
  },

  async generate(name: string): Promise<GeneratedApiKey> {
    const res = await http.post<ActionResponse<GeneratedApiKeyDtoWire>>(BASE, { name });
    return mapGenerated(unwrap(res));
  },

  async rotate(id: string): Promise<GeneratedApiKey> {
    const res = await http.post<ActionResponse<GeneratedApiKeyDtoWire>>(`${BASE}/${id}/rotate`);
    return mapGenerated(unwrap(res));
  },

  async revoke(id: string): Promise<void> {
    const res = await http.delete<ActionResponse<boolean>>(`${BASE}/${id}`);
    unwrap(res);
  },
};
